import { theme } from 'antd'

import { History } from '../../../atoms/history/types'
import { HistoryCard } from './HistoryCard'

type HistoriesListProps = {
  items: History[] | undefined
  requestId: string
  selectedRequestId: string | null
  onSelect: (requestId: string) => void
}

export const HistoriesList = ({
  items,
  requestId,
  selectedRequestId,
  onSelect,
}: HistoriesListProps) => {
  const { token } = theme.useToken()

  return (
    <>
      {items &&
        items?.length > 0 &&
        items?.map((item) => {
          return (
            <HistoryCard
              key={item.requestId}
              item={item}
              isSelected={item.requestId === selectedRequestId}
              onClick={() => onSelect(item.requestId)}
              marginBottom={token.marginXS}
              currentRequestId={requestId}
            />
          )
        })}
    </>
  )
}
